<template>
  <div>
    <Dialog
      :key="tagFormKey"
      :visible.sync="tagForm1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Tag Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="tagName">Tag Name*</label>
          <InputText
            id="tagName"
            v-model.trim="tag.tag"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !tag.tag }"
            :disabled="disabledArr.includes('tagName')"
          />
          <small class="p-invalid" v-if="submitted && !tag.tag"
            >Tag Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="tagType">Tag Type*</label>
          <Dropdown
            :showClear="true"
            v-model="tag.type"
            :options="types"
            optionLabel="name"
            dataKey="id"
            placeholder="Select tag type"
            :disabled="disabledArr.includes('tagType')"
          />
          <small class="p-invalid" v-if="submitted && !tag.type"
            >Tag Type is required.</small
          >
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="lastName">Tag Active</label>
          <SelectButton
            v-model="tag.active"
            :options="options"
            optionLabel="name"
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Reset"
          icon="pi pi-refresh"
          class="p-button-warning"
          style="width: 100px;"
          @click="reset"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="hideDialog"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="save"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import TagsService from "@/service/TagsService";

import { tagRequest } from "../sendRequest";

export default {
  props: ["tagToEdit", "tagForm", "disabledArr"],
  data: () => ({
    tagsService: new TagsService(),
    tag: {},
    submitted: false,
    options: [
      { name: "Active", value: true },
      { name: "Inactive", value: false }
    ],
    tagFormKey: 0,
    types: [
      { id: 1, name: "CUSTOMER" },
      { id: 2, name: "ATTACHMENT" },
      { id: 3, name: "NOTES" }
    ],
    sendingRequest: false
  }),
  created() {
    this.setupTag();
  },
  computed: {
    tagForm1: {
      set(val) {
        if (!val) {
          this.hideDialog();
        }
      },
      get() {
        if (this.tagForm) {
          this.setupTag();
          this.tagFormKey++;
        }
        return this.tagForm;
      }
    }
  },
  methods: {
    setupTag() {
      this.submitted = false;
      this.tag = {};

      if (this.tagToEdit.id) {
        this.tag = { ...this.tagToEdit };
        this.tagToEdit.active
          ? (this.tag.active = { name: "Active", value: true })
          : (this.tag.active = { name: "Inactive", value: false });
        if (typeof this.tagToEdit.type === "string") {
          this.tag.type = this.types.find(
            tag => tag.name === this.tagToEdit.type
          );
        }
      }
    },
    reset() {
      this.tag = {};
    },
    save() {
      this.submitted = true;
      this.sendingRequest = true;

      tagRequest(this, "tagForm.vue");
    },
    hideDialog() {
      this.$emit("close");
    }
  }
};
</script>

<style></style>
